// extracted by mini-css-extract-plugin
module.exports = {"item":"b49a62dc46--item--ihWga"};